var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.324,
    height: 13.199,
    viewBox: "0 0 12.324 13.199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92",
    transform: "translate(5.724) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_9",
    "data-name": "\\uC120 9",
    d: "M8.667,1.333h-8A.667.667,0,0,1,.667,0h8a.667.667,0,1,1,0,1.333Z",
    transform: "translate(0 0)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_10",
    "data-name": "\\uC120 10",
    d: "M.667,9.333A.667.667,0,0,1,0,8.667v-8a.667.667,0,0,1,1.333,0v8A.667.667,0,0,1,.667,9.333Z",
    transform: "translate(8 0)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_11",
    "data-name": "\\uC120 11",
    d: "M.667,8.714A.667.667,0,0,1,.2,7.576L7.576.2a.667.667,0,1,1,.943.943L1.138,8.519A.665.665,0,0,1,.667,8.714Z",
    transform: "translate(0.619 0)",
    fill: "#e5e5e5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.8feaf44577b01dfbb0baa09b094933cd.svg";
export { ForwardRef as ReactComponent };